/**
 * Mobile announcement fade carousel.
 *
 * - Fades between stacked single-line items (no layout shift).
 * - Pauses on hover / touch / keyboard focus and when the page is hidden.
 * - Respects prefers-reduced-motion (no rotation; first item stays visible).
 * - No-JS fallback: the first item is visible via CSS.
 */
(function () {
  'use strict';

  var items = Array.prototype.slice.call(document.querySelectorAll('.announcement-bar__mobile-item'));
  var slides = document.querySelector('.announcement-bar__slides');

  if (items.length < 2 || !slides) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  var bar = slides.closest('.announcement-bar');
  if (!bar) return;

  var speed = parseInt(bar.dataset.speed || '4', 10) * 1000;
  var current = 0;
  var timer = null;

  function show(index) {
    items[current].classList.remove('is-active');
    current = index % items.length;
    items[current].classList.add('is-active');
  }

  function start() {
    stop();
    slides.classList.add('is-rotating');
    items[current].classList.add('is-active');
    timer = window.setInterval(function () {
      show(current + 1);
    }, speed);
  }

  function stop() {
    if (timer) {
      window.clearInterval(timer);
      timer = null;
    }
  }

  bar.addEventListener('mouseenter', stop);
  bar.addEventListener('mouseleave', start);
  bar.addEventListener('focusin', stop);
  bar.addEventListener('focusout', start);
  bar.addEventListener('touchstart', stop, { passive: true });
  bar.addEventListener('touchend', start);

  document.addEventListener('visibilitychange', function () {
    if (document.hidden) {
      stop();
    } else {
      start();
    }
  });

  start();
})();
